export default {
    'order.title.statistic.ordertotalamount': '订单总金额',
    'order.title.statistic.ordertotalnumber': '订单总笔数',
    'order.title.statistic.ordertotalfee': '订单总服务费',
    'order.title.statistic.mix': '占比',
    'order.export.type.orderin': '代收',
    'order.export.type.orderout': '代付',
    'order.export.type.assetlog': '流水',
    'order.nameLabel.id': '序号',
    'order.nameLabel.orderno': '订单号',
    'order.nameLabel.merchantorderno': '商户订单号',
    'order.nameLabel.currency': '币种',
    'order.nameLabel.status': '状态',
    'order.nameLabel.amount': '金额',
    'order.nameLabel.realamount': '入帐金额',
    'order.nameLabel.servicefee': '服务费',
    'order.nameLabel.updatetime': '完成时间',
    'order.nameLabel.orderstatus': '订单状态',
    'order.nameLabel.date': '订单时间',
    'order.nameLabel.datetime': '创建时间',
    'order.nameLabel.datefrom': '开始时间',
    'order.nameLabel.dateto': '结束时间',
    'order.nameLabel.type': '类型',
    'order.nameLabel.cpf': 'CPF 税号',
    'order.nameLabel.account': '账号',
    'order.nameLabel.name': '姓名',
    'order.nameLabel.email': '邮箱',
    'order.nameLabel.phone': '电话',
    'order.nameLabel.oldamount': '原有余额',
    'order.nameLabel.newamount': '现有余额',
    'order.nameLabel.oldamountfrozen': '原有冻结余额',
    'order.nameLabel.newamountfrozen': '现有冻结余额',
    'order.nameLabel.changeamount': '余变更金额',
    'order.nameLabel.businesscode': '业务编码',
    'order.nameLabel.customeraccount': '联系人账户',
    'order.nameLabel.customername': '联系人名称',
    'order.nameLabel.customeremail': '联系人游邮箱',
    'order.nameLabel.customerphone': '联系人手机',
    'order.nameLabel.signtype': '签名方式',
    'order.asset.type1': '代收入账',
    'order.asset.type2': '代付出账',
    'order.asset.type3': '余额冻结',
    'order.asset.type4': '余额解冻',
    'order.asset.type5': '代收冲正',
    'order.asset.type6': '代付冲正',
    'order.asset.type7': '回u出账',
    'order.asset.type8': '余额内转',
    'order.status.success': '成功',
    'order.status.pending': '等待',
    'order.status.close': '关闭',
    'order.status.failed': '失败',
    'order.status.wait': '等待',
    'order.status.complete': '完成',
    'order.button.export': '导出',
    'order.button.statistic': '统计',
};
